// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".addressBox[data-v-5d75e27a]{width:100%;min-width:320px;min-height:36px;border-radius:4px;border:1px solid #dcdfe6;background-color:#fff;background-image:none;box-sizing:border-box;display:flex;flex-wrap:wrap;justify-content:flex-start;align-content:flex-start}.addAddress[data-v-5d75e27a]{color:#286ab4}.el-tag--medium[data-v-5d75e27a]{margin-left:5px;margin-top:5px}", ""]);
// Exports
module.exports = exports;
